import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonService} from './core/services/common.service';
import {HttpClientService} from './core/services/http-client.service';
import {ToastService} from './core/services/toast.service';
import {routing} from './app.routing';
import {CurrenySymbol} from './shared/directives/custom.directive';
import {InterceptedHttpService} from './core/interceptors/http.interceptor';
import {LoaderService} from './core/services/loader.service';
import {RetailerRegisterService} from './core/services/retailer-register.service';
import {DashboardGuard} from './core/guards/gaurds';
import {WindowRefService} from './window-ref.service';
import {SplashScreenStateService} from './core/services/splash-screen-state.service';
import {MaterialModule} from './shared/material.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {FeaturesModule} from "./features/features.module";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NotFoundComponent} from "./features/components/not-found/not-found.component";
import {HomepageResolver} from "./homepage-resolver.service";
import {AffiliateModule} from "./affiliate/affiliate.module";


@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    CurrenySymbol,
  ],
  bootstrap: [AppComponent],
  imports: [
      BrowserModule,
      FormsModule,
      BrowserAnimationsModule,
      MaterialModule,
      FeaturesModule,
      AffiliateModule,
      routing,
    NgbModule
  ],
  providers: [
      SplashScreenStateService,
      CommonService,
      HttpClientService,
      ToastService,
      RetailerRegisterService,
      DashboardGuard,
      {
          provide: HTTP_INTERCEPTORS,
          useClass: InterceptedHttpService,
          multi: true,
      },
      LoaderService,
      HomepageResolver,
      WindowRefService,
      provideHttpClient(withInterceptorsFromDi())
  ]})
export class AppModule {
}
